import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';


const SectionBenefitsItem = ({ item }) => {
  // const [Icon, setIcon] = useState(null);

  // useEffect(() => {
  //   import(`@/images/${icon}.png`).then(module => setIcon(module.default));
  // }, [icon]);

  return (
    <div className="flex flex-col lg:flex-row items-center lg:gap-4">
      <img src={item.image.url} alt={item.header} className="py-6 h-[112px]" />
      <div>
        <h3  className={item.headerClasses}>{parse(item.header)}:</h3>
        <div className="text-base font-normal">{parse(item.body)}</div>
      </div>
    </div>
  );
};

SectionBenefitsItem.propTypes = {
  item: PropTypes.shape({
    header: PropTypes.string.isRequired,
    headerClasses: PropTypes.string,
    body: PropTypes.string.isRequired,
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
  })})
};

export default SectionBenefitsItem;
